import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { AdminProductMetricsDTO, AdminProductSearchDTO, ResponseList } from 'app/modules/products/list-products/product';
import { Observable } from 'rxjs';
import { AdminSellerInfoMetricsDTO, Announcements } from './announcement';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
    private _httpClient = inject(HttpClient);
    private readonly _baseUrl = 'admin/product';

    /**
     * update an announcement (product)
     *
     * @param item
     */
    update(item: Announcements): Observable<Announcements> {
        return this._httpClient.post<Announcements>(
            'admin/product/update',
            item
        );
    }

    reject(item: Announcements): Observable<Announcements> {
        return this._httpClient.post<Announcements>(
            'admin/product/reject',
            item
        );
    }

    load(id: string): Observable<Announcements> {
        return this._httpClient.get<Announcements>('admin/product/' + id);
    }
   
    getSellerInfo(id: string): Observable<AdminSellerInfoMetricsDTO> {
        return this._httpClient.get<AdminSellerInfoMetricsDTO>('admin/product/getSellerInfo/' + id);
    }

    uploadMedia(file: File, productId: string): Observable<{ url: string }> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('productId', productId);

        return this._httpClient.post<{ url: string }>(
            'admin/product/upload',
            formData
        );
    }

    /**
     * Search products (announcements)
     * @param search
     */
    search(
        search: AdminProductSearchDTO
    ): Observable<ResponseList<AdminProductMetricsDTO>> {
        const params: any = {};
        Object.entries(search).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params[key] = value;
            }
        });
        return this._httpClient.get<ResponseList<AdminProductMetricsDTO>>(
            `${this._baseUrl}/search`,
            {
                params,
            }
        );
    }

    searchMetrics(search: any): Observable<any> {
        return this._httpClient.post('product/search/metrics', search);
    }

    /**
     * Update product status
     * @param id
     * @param status
     */
    updateStatus(
        id: string,
        status: string
    ): Observable<any> {
        return this._httpClient.post(`${this._baseUrl}/${id}/status`, null, {
            params: { status },
        });
    }

    createStory(id: string): Observable<any> {
        return this._httpClient.post(`${this._baseUrl}/${id}/story`, null);
    }

    deactivateStory(id: string): Observable<any> {
        return this._httpClient.delete(`${this._baseUrl}/${id}/story`);
    }
}
